import apiRequest from './apiRequest';

export type CreateCharacterUploadRequest = {
  characterName?: string;
  characterDescription?: string;
  createdByUser?: string;
  fileExtension: string;
  thumbnailExtension?: string;
};

export type CreateCharacterUploadResponse = {
  characterID: string;
  fileExtension: string;
  characterFileUploadURL: string;
  configUploadURL: string;
  tempConfigUploadURL: string;
  thumbnailUploadURL?: string | null;
  estimatedSecondsWaitTime: number;
};

/**
 * Create character upload link (POST /characters/upload).
 * Returns presigned URLs to PUT the character file, saved config JSON, session temp-config JSON, and optional thumbnail.
 * @see https://api-docs.getcartwheel.com/api/call-create-character-upload
 */
export default async function postCreateCharacterUpload(
  apiKey: string,
  body: CreateCharacterUploadRequest,
) {
  return apiRequest<CreateCharacterUploadResponse>(
    'external-mogen',
    '/characters/upload',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(body),
    },
  );
}
